import React, {Component} from 'react';
import {observer} from 'mobx-react';

import Field from 'lib/struct/form/fields/Field';
import Select from 'lib/struct/form/Select';
import SpanLink from 'lib/struct/pseudo_link/PseudoLinkBox';
import RedactorTextarea from 'lib/struct/form/RedactorTextarea';

import * as MarkupTemplateId from 'settings/constant/MarkupTemplateId';

import styles from './TemplateForm.less';

@observer export default class SimpleGroupTemplateForm extends Component {
	render() {
		/** @type {SettingsContext} */
		const context = this.props.context;

		const theme_id = context.current_theme_id;

		const markup_settings = context.settings.markup_template_theme_settings.get(theme_id);
		const meta = context.templates_meta.get(MarkupTemplateId.SIMPLE_GROUP);

		const is_custom = !markup_settings.is_simple_group_template_default;
		const onCustomChange = is_custom => context.updateCurrentThemeMarkupTemplateSettingsValue('is_simple_group_template_default', !is_custom);
		const template = markup_settings.simple_group_template;
		const is_modified = template !== meta.plugin_template;
		const onTemplateChange = value => context.updateCurrentThemeMarkupTemplateSettingsValue('simple_group_template', value);
		const onResetToDefault = () => context.updateCurrentThemeMarkupTemplateSettingsValue('simple_group_template', meta.plugin_template);

		const options = [{
			label: 'По умолчанию',
			value: '0',
		},{
			label: `Свой шаблон (${meta.theme_file_name})`,
			value: '1',
		},];

		return (
			<div>
				<Field>
					<Select
						options={options}
						value={is_custom ? '1' : '0'}
						onChange={e => onCustomChange(e.target.value === '1')}
					/>

					{
						is_custom && is_modified ? (
							<SpanLink
								onClick={() => confirm('Восстановить стандартный шаблон?') && onResetToDefault()}
								title='Восстановить стандартный шаблон'
								className={styles['restore-template']}
							>
								<i className='icon16 rotate-left' />
							</SpanLink>
						) : (null)
					}
				</Field>

				{
					is_custom ? (
						<RedactorTextarea
							value={template}
							onChange={e => onTemplateChange(e.target.value)}
						/>
					) : (null)
				}
			</div>
		);
	}
}